import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button} from "reactstrap";
import CardHeader from "@material-ui/core/CardHeader";
import Select from "react-select";
import API from "@beardeddevops/react.api";

class SubRegion extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Regions_Subs._name);
	}

	handleRegionSelect = async (property, value, linked, object) => {
		this.model.parent = value;

		this.handleSelectPropertyUpdate(property, value, linked, object);
	}

	render() {
		const {properties} = this.model;
		let object = this.state;
		let {
			loaded,
			region,
			region_error,
			regions,
		} = this.state;

		return (
			<fieldset>
						<div className={'row'}>
							<div className={'col-6'}>
								<Framework.Elements.Select
									shouldLoad={loaded}
									property={properties.region}
									value={region}
									error={region_error}
									object={regions}
									update={this.handleRegionSelect}
									nullable={true}
								/>
							</div>
							<div className={'col-6'}>
								<Framework.Elements.TextField
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
			</fieldset>
		)
	}
}

export default Framework.Components.withRootState(SubRegion);
